import React from "react";
import { ticketPriorityLabel, ticketStatusLabel, TICKET_PRIORITY, TICKET_STATUS } from "./ticketApi";

export const StatusBadge = ({ status, statusName }) => {
  const value = Number(status);
  const className =
    value === TICKET_STATUS.Open
      ? "help-support-badge--open"
      : value === TICKET_STATUS.InProgress
        ? "help-support-badge--inprogress"
        : value === TICKET_STATUS.Resolved
          ? "help-support-badge--resolved"
          : "help-support-badge--closed";

  return (
    <span className={`help-support-badge ${className}`}>
      {statusName || ticketStatusLabel(value)}
    </span>
  );
};

export const PriorityBadge = ({ priority, priorityName }) => {
  const value = Number(priority);
  const className =
    value === TICKET_PRIORITY.Low
      ? "help-support-badge--priority-low"
      : value === TICKET_PRIORITY.High
        ? "help-support-badge--priority-high"
        : value === TICKET_PRIORITY.Critical
          ? "help-support-badge--priority-critical"
          : "help-support-badge--priority-medium";

  return (
    <span className={`help-support-badge ${className}`}>
      {priorityName || ticketPriorityLabel(value)}
    </span>
  );
};

export const formatTicketDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
};

export const PROBLEM_TYPE_OPTIONS = [
  { value: "Technical Issue", labelKey: "technicalIssue", defaultValue: "Technical Issue" },
  { value: "Billing Question", labelKey: "billingQuestion", defaultValue: "Billing Question", adminOnly: true },
  { value: "Feature Request", labelKey: "featureRequest", defaultValue: "Feature Request", adminOnly: true },
  { value: "Bug Report", labelKey: "bugReport", defaultValue: "Bug Report" },
  { value: "Other", labelKey: "other", defaultValue: "Other" },
];

/** Manager (3) and standard user (4) cannot pick billing/feature-request types. */
export const getProblemTypeOptionsForRole = (roleId) => {
  const id = Number(roleId);
  const isAdmin = id === 1 || id === 2;
  if (isAdmin) return PROBLEM_TYPE_OPTIONS;
  return PROBLEM_TYPE_OPTIONS.filter((opt) => !opt.adminOnly);
};

export const STATUS_OPTIONS = [
  { value: TICKET_STATUS.Open, label: "Open" },
  { value: TICKET_STATUS.InProgress, label: "In Progress" },
  { value: TICKET_STATUS.Resolved, label: "Resolved" },
  { value: TICKET_STATUS.Closed, label: "Closed" },
];

export const PRIORITY_OPTIONS = [
  { value: TICKET_PRIORITY.Low, label: "Low" },
  { value: TICKET_PRIORITY.Medium, label: "Medium" },
  { value: TICKET_PRIORITY.High, label: "High" },
  { value: TICKET_PRIORITY.Critical, label: "Critical" },
];
